import script from "./StepMedicalVisitInline.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepMedicalVisitInline.vue?vue&type=script&setup=true&lang=ts"

import "./StepMedicalVisitInline.vue?vue&type=style&index=0&id=7aff1b94&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aff1b94"]])

export default __exports__